var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rkm-modal',{ref:"RkmModal",attrs:{"extra-large":"","hide-footer":"","title":"Lista de logradouros"}},[_c('List',{attrs:{"classificacao_id":_vm.classificacao_id,"selection-mode":""},on:{"select":_vm.handleExit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }